<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">分类：</div>
        <el-select class="filter__input" size="mini" v-model="filters.scid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.scid" v-for="(item, index) in categoryLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">渠道ID：</div>
        <el-input v-model="filters.chnid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
    </div>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-radio-group v-model="filters.status">
          <div class="dib mr-20">
            <el-radio :label="item.value" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
      <div class="ml-auto">
        <router-link class="blue-small-btn" :to="{path: '/shopGoodsEdit', query: {sgid: 0}}">新建</router-link>
      </div>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="sgid" label="商品ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="chnid" label="用户ID" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('chnid', scope.row.chnid)">{{scope.row.nickname}}({{scope.row.chnid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="scid" label="分类ID" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('scid', scope.row.scid)">{{scope.row.category_title}}({{scope.row.scid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="icon" label="icon图">
        <template slot-scope="scope">
          <div class="mt10">
            <img :src="scope.row.icon" height="60px" weight="60px" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="feature" label="特征类别" width="" align="center">
      </el-table-column>
      <el-table-column prop="origin_price" label="原价" width="" align="center">
      </el-table-column>
      <el-table-column prop="price" label="单价" width="" align="center">
      </el-table-column>
      <el-table-column prop="total" label="总量" width="" align="center">
      </el-table-column>
      <el-table-column prop="sold" label="已售" width="" align="center">
      </el-table-column>
      <el-table-column prop="stock" label="库存" width="" align="center">
      </el-table-column>
      <el-table-column prop="lock_stock" label="锁定库存" width="" align="center">
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">下架</div>
          <div v-if="scope.row.status == 1">上架</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex">
            <router-link :to="{path: '/shopGoodsEdit', query: {sgid: scope.row.sgid}}" class="blue-small-btn mr-10">编辑</router-link>
            <router-link :to="{path: '/shopGoodsStockFull', query: {sgid: scope.row.sgid}}" class="blue-small-btn">添加库存</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopGoodsLists, shopGoodsEdit, shopCategoryLists} from '../../../api/api'
export default {
  name: 'shopGoodsList',
  mixins: [mixinList],
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        scid: '',
        chnid: '',
        title: '',
        status: ''
      },
      categoryLists: [],
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      dialog: false
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.scid !== '') {
        params.scid = filters.scid
      }
      if (filters.chnid !== '') {
        params.chnid = filters.chnid
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      this.listLoading = true
      shopGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    getCategoryLists () {
      let params = {
      }

      this.listLoading = true
      shopCategoryLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.categoryLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.scid + ')',
              scid: item.scid
            }
          })
          this.categoryLists.unshift({
            title: '所有',
            scid: ''
          })
        }
      })
    },

    changeGoodsinfo (index, oper) {
      let status = this.lists[index].status
      let suid = this.lists[index].suid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        suid: suid
      }
      shopGoodsEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    }
  },
  mounted () {
    this.getList()

    this.getCategoryLists()
  },
  watch: {
    'filters.scid': 'getList',
    'filters.chnid': 'getList',
    'filters.title': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopGoodsList.vue